import type { AuthSession, AuthUser } from '@jira/shared';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { setAuthHeader } from '@/lib/api';

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  user: AuthUser | null;
  activeOrgId: string | null;
  setSession: (session: AuthSession) => void;
  setUser: (user: AuthUser) => void;
  setActiveOrgId: (orgId: string | null) => void;
  clear: () => void;
}

const STORAGE_KEY = 'jira.auth';

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      activeOrgId: null,
      setSession: (session) => {
        setAuthHeader(session.accessToken);
        set({
          accessToken: session.accessToken,
          refreshToken: session.refreshToken,
          user: session.user,
          activeOrgId: session.user.memberships[0]?.organizationId ?? null,
        });
      },
      setUser: (user) => set({ user }),
      setActiveOrgId: (orgId) => set({ activeOrgId: orgId }),
      clear: () => {
        setAuthHeader(null);
        set({ accessToken: null, refreshToken: null, user: null, activeOrgId: null });
      },
    }),
    {
      name: STORAGE_KEY,
      partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        user: state.user,
        activeOrgId: state.activeOrgId,
      }),
      onRehydrateStorage: () => (state) => {
        if (state?.accessToken) {
          setAuthHeader(state.accessToken);
        }
      },
    },
  ),
);
